(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.headerCoords = {};
      this.calcHeaderCoords();

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => {
        this.preventReveal = true;
      };

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    calcHeaderCoords() {
      const clientRect = this.getBoundingClientRect();
      const pageYOffset = window.pageYOffset || document.documentElement.scrollTop;
      this.headerCoords.bottom = pageYOffset + clientRect.bottom;
      this.headerCoords.top = pageYOffset + clientRect.top;
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.headerIsAlwaysSticky) {
        if (scrollTop > this.header.offsetHeight + 1) {
          this.header.classList.add('shopify-section-header-sticky');
        }

        if (scrollTop < this.header.offsetHeight) {
          this.header.classList.remove('shopify-section-header-sticky');
        }
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerCoords.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      if (customElements.get('details-disclosure')) {
        this.disclosures.forEach((disclosure) => {
          disclosure.close();
        });
      }

      this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
      this.disclosureLists.forEach((disclosureList) => {
        disclosureList.setAttribute('hidden', true);
      });
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  const initializeIngredientLinks = (scope = document) => {
    scope.querySelectorAll('.rd-pdp-reassurance__ingredients-link').forEach((link) => {
      const productInfo = link.closest('.product-info-container');
      const description = productInfo?.querySelector('.product-description-wrapper');
      if (!description) return;
      const heading = [...description.querySelectorAll('h2, h3, h4, h5, h6')]
        .find((element) => /^ingredients\b/i.test(element.textContent.trim()));
      if (!heading) return;
      if (!heading.id) heading.id = `${description.id}-ingredients`;
      heading.classList.add('rd-pdp-ingredients-target');
      heading.tabIndex = -1;
      link.setAttribute('href', `#${heading.id}`);
    });
  };
  initializeIngredientLinks();
  document.addEventListener('shopify:section:load', (event) => initializeIngredientLinks(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rd-story-signoff"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rd-signoff-fit')) {
    customElements.define('rd-signoff-fit', class extends HTMLElement {
      connectedCallback() {
        this.fit = () => {
          if (!this.isConnected) return;
          const available = this.clientWidth - 10;
          if (available <= 0) return;
          this.querySelectorAll('.rd-story-signoff__line').forEach((line) => {
            line.style.setProperty('--rd-fitted-size', '100px');
            const width = line.getBoundingClientRect().width;
            if (width > 0) line.style.setProperty('--rd-fitted-size', `${100 * available / width}px`);
          });
        };
        this.observer = new ResizeObserver(() => {
          if (this.lastWidth === this.clientWidth) return;
          this.lastWidth = this.clientWidth;
          this.fit();
        });
        this.observer.observe(this);
        document.fonts.ready.then(this.fit);
        document.fonts.addEventListener('loadingdone', this.fit);
      }
      disconnectedCallback() {
        this.observer.disconnect();
        document.fonts.removeEventListener('loadingdone', this.fit);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
